<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de selección de Contactos/Clientes--->
<p-dialog header="Buscador de clientes"
          [(visible)]="visible" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="cerrarPopup(false);"    
          [closable]="true"
          styleClass="p-dialog-product">
    <ng-template pTemplate="header">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">Tus Contactos/Clientes, </span>
                <span class="text-blue-600">listos para que factures..</span>
            </div>
            <div class="text-700 text-sm mb-2">Busca a tus Contactos/Clientes <strong>{{currentUser.initials}}</strong>.</div>
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="filteredSubjectCustomerByKeyword($event)"
                        placeholder="{{appConfig.ux.searchMsg}}"
                        class="w-full"/>
                </span>
                <button pButton pRipple
                        type="button" 
                        pTooltip="{{ appConfig.ux.actions.add }}" tooltipPosition="bottom"
                        icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-sm ml-1"
                        (click)="nuevoContacto()">
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center">
            <div class="grid">
                <p-card *ngFor="let item of subjectCustomersFiltered"
                        class="p-field col-12 md:col-6"
                        header="{{item.customerFullName}}" 
                        subheader="{{item.customerEmail}}" 
                        styleClass="surface-card">
                    <ng-template pTemplate="footer">
                        <p><small>Emitir comprobante con</small></p>
                        <p-button [styleClass]="(subjectCustomer && subjectCustomer.customerFullName && subjectCustomer.customerFullName == item.customerFullName) ? 'bg-bluegray-100 shadow-1 p-3 h-full w-full' : 'p-button-text shadow-1 p-3 h-full w-full bg-green-200'"
                                  (click)="seleccionarContacto($event, item, false)"
                                  (dblClick)="seleccionarContacto($event, item, false);">
                            <ng-template pTemplate="content">
                                <div class="flex-auto  w-full">
                                    <img [src]="item.customerImage" class="h-2rem"/>
                                    <div class="text-900 mt-1 mb-3 font-medium">{{item.customerCode}}</div>
                                    <div class="text-700 mb-3 text-sm line-height-3 text-blue-600">{{item.customerCodeType}}</div>
                                </div>
                            </ng-template>
                        </p-button>
                        <p-button [styleClass]="(subjectCustomer && subjectCustomer.customerFullName && subjectCustomer.customerFullName == item.customerFullName) ? 'bg-bluegray-100 shadow-1 p-3 h-full w-full' : 'p-button-text shadow-1 p-3 h-full w-full bg-green-100'"
                                  (click)="seleccionarContacto($event, item, true)"
                                  (dblClick)="seleccionarContacto($event, item, true);"
                                  *ngIf="item.customerCodeType == 'RUC' && item.esPersonaNatural">
                            <ng-template pTemplate="content">
                                <div class="flex-auto  w-full">
                                    <img [src]="item.customerImage" class="h-2rem"/>
                                    <div class="text-900 mt-1 mb-3 font-medium">{{item.nui}}</div>
                                    <div class="text-700 mb-3 text-sm line-height-3 text-blue-600">CEDULA</div>
                                </div>
                            </ng-template>
                        </p-button>
                    </ng-template>
                </p-card>
                <div *ngIf="(!subjectCustomersFiltered || !subjectCustomersFiltered.length)"
                     class="col-12 md:col-12 mb-1 p-6">
                    <i *ngIf="!processFilter" class="pi pi-users text-8xl"></i>
                    <br>
                    <strong *ngIf="!processFilter && (subjectCustomers && subjectCustomers.length)">{{appConfig.ux.emptyMsg}}</strong>
                    <i *ngIf="processFilter" class="pi pi-spin pi-spinner text-8xl"></i>
                </div>  
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<!-- Editor de contacto -->
<app-contacto [mostrarEditor] = "mostrarEditor" 
              [subjectCustomer] ="subjectCustomer"
              [estaCargandoDatos] = "false"
              (contactoGuardado) = "handleContactoGuardado($event);"></app-contacto>